import { BaseEmoji } from 'emoji-mart/dist-es/utils/emoji-index/nimble-emoji-index';
// eslint-disable-next-line no-restricted-imports
import { ReactionModel } from 'types/models';
// eslint-disable-next-line no-restricted-imports
import { convertSkinToEmojiMartFormat } from 'util/model-helpers/reactions';

// eslint-disable-next-line no-restricted-imports
import { EmojiResponse, ReactionResponse } from 'types/responses';

import { normalizeMember } from './member';

import genericNormalizer from './generic';

export const normalizeEmoji = genericNormalizer<EmojiResponse, BaseEmoji>(
  ({ from, has, combine, fallback }) => {
    return {
      id: has('shortName', (shortName) => shortName.toUpperCase()),
      name: from('name'),
      colons: combine(
        ['shortName', 'skinVariation'],
        ({ shortName, skinVariation }) =>
          `:${shortName}${
            skinVariation
              ? `::skin-tone-${convertSkinToEmojiMartFormat(skinVariation)}`
              : ''
          }:`,
      ),
      emoticons: fallback(from('emoticons'), []),
      unified: from('unified'),
      skin: has(
        'skinVariation',
        (skinVariation) =>
          skinVariation ? convertSkinToEmojiMartFormat(skinVariation) : null,
      ),
      native: from('native'),
    };
  },
);

export const normalizeReaction = genericNormalizer<
  ReactionResponse,
  ReactionModel
>(({ from, has }) => ({
  id: from('id'),
  idEmoji: has('idEmoji', (idEmoji) => idEmoji.toUpperCase()),
  idMember: from('idMember'),
  idModel: from('idModel'),
  member: has('member', normalizeMember),
  emoji: has('emoji', normalizeEmoji),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/reaction.ts